import { createAction, props } from '@ngrx/store';

import { SoilAnalysis, State } from '../models/soil-analysis.models';

export const openOverview = createAction('[Soil analysis] Open overview');

export const loadDefaultSoilAnalyses = createAction(
  '[Soil analysis] Load default soil analysis request',
);

export const loadDefaultSoilAnalysesSuccess = createAction(
  '[Soil analysis] Load default soil analysis success',
  props<{ defaultSoilAnalyses: SoilAnalysis[] }>(),
);

export const addDefaultSoilAnalysis = createAction('[Soil analysis] Add new default soil analysis');

export const editDefaultSoilAnalysis = createAction(
  '[Soil analysis] Edit default soil analysis',
  props<{ defaultSoilAnalysis: SoilAnalysis }>(),
);

export const upsertDefaultSoilAnalysis = createAction(
  '[Soil analysis] Upsert default soil analysis',
  props<{ defaultSoilAnalysis: SoilAnalysis }>(),
);

export const changeStateDefaultSoilAnalysis = createAction(
  '[Soil analysis] Change state default soil analysis',
  props<{ id: number; state: State }>(),
);
